import * as React from 'react';

/** Holds only whether the element is narrower than `maxWidth`, so a resize re-renders only when that flips; an unmeasured (0) width reads as wide. */
export function useIsNarrowerThan<TElement extends HTMLElement>(
  maxWidth: number,
  enabled: boolean,
) {
  const ref = React.useRef<TElement>(null);
  const [narrow, setNarrow] = React.useState(false);
  React.useLayoutEffect(() => {
    const element = ref.current;
    if (!enabled || !element || typeof ResizeObserver === 'undefined') return;
    const observer = new ResizeObserver(([entry]) => {
      if (entry) setNarrow(entry.contentRect.width > 0 && entry.contentRect.width < maxWidth);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [enabled, maxWidth]);
  return [ref, narrow] as const;
}
